import Form from "../../../ui/Form";
import LocationField from "./LocationField";
import BrandField from "./BrandField";
import ForwardField from "./ForwardField";
import { extractValues, filterValues } from "../../../utils/stockList.utils";

export default function StockListFilterForm({ onClose, onFilter }) {
  const fields = [
    {
      name: "brandField",
      type: "custom",
      customComponent: BrandField,
      col: { md: 12 }
    },
    {
      name: "locationField",
      type: "custom",
      customComponent: LocationField,
      col: { md: 12 }
    },
    {
      name: "forwardField",
      type: "custom",
      customComponent: ForwardField,
      col: { md: 12 }
    }
  ];

  const { setFilter, getFilter } = filterValues();

  const filteredValues = getFilter() ?? {};

  const defaultValues = {
    ...filteredValues
  };

  const onSubmit = (data) => {
    setFilter({ ...data, t: Date.now() });
    const { values } = extractValues(data);
    onFilter(values);

    onClose();
  };

  return (
    <Form
      fields={fields}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      submitbtnText={"Filter"}
      loading={false}
      closebtnText={"Close"}
      onClose={onClose}
    />
  );
}
